import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pick-ban';
}

// Reset
// Pen
// Settings
// Help
// Pro Draft
// Free Draft

// Colors: Red, Blue, Green, Yellow, Black, White, Gray, Purple, Pink, Orange, 
